// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4686b396","186":"f6781bbf","344":"5e702aac","372":"dce961bb","377":"cce4a1e3","738":"e14e7e2c","841":"092e18ab","856":"6777f4a7","858":"ddf54c1d"}[chunkId] + ".chunk.js";
};